import { USER_FIELD_LABELS, USER_PERMISSION_FIELDS } from '../../UserDrawer/userFormValues';

/**
 * The fields of a user import row, in the template's column order (kept the same as the
 * backend's USER_IMPORT_COLUMNS). Each row's values are as the backend's toUserBody gives
 * them: text, ids as text or null, brokerGroupArray a list of ids, and each permission flag
 * true / false, or the text as written when it isn't Yes / No.
 */
export const USER_IMPORT_FIELDS = [
	'email',
	'name',
	'brokerGroupId',
	'brokerGroupArray',
	'phoneNumber',
	'role',
	'salesTeamId',
	'serviceTeamId',
	'accountTypeId',
	'authorisedRepId',
	...USER_PERMISSION_FIELDS,
];

/** A user import field's label, as in the user drawers. */
export const getImportFieldLabel = (field) => USER_FIELD_LABELS[field];

/** An import row's values as spreadsheet text: lists joined, flags as Yes / No. */
export const getImportValueText = (field, value) => {
	if (USER_PERMISSION_FIELDS.includes(field) && typeof value === 'boolean') {
		return value ? 'Yes' : 'No';
	}
	return Array.isArray(value) ? value.join(', ') : (value ?? '');
};
